<div class="row mb-3 mt-2">

    
    <!-- Commented on 20th april 2026 for the breadcrumb changes -->
    <!-- <div class="card-header bg-white py-3" [hidden]="showselector">
        <div>
            <div class="col-6 mb-2">
                <label for="name" class="form-label">Plant:</label>
                <select class="form-select border border-dark" name="plantid" (change)="getSelectedId($event)">
                    <option [selected]>Select Plant</option>
                    <option *ngFor="let plant of plants" [value]="plant.Id">
                        {{ plant.Name }}
                    </option>
                </select>
            </div>
            <div class="col-6">
                <label for="train" class="form-label">Train:</label>
                <select class="form-select border border-dark" name="trainid" (change)="getSelectedTrainId($event)">
                    <option [selected]>Select Train</option>
                    <option *ngFor="let train of trains" [value]="train.Id">
                        {{ train.Name }}
                    </option>
                </select>
            </div>
        </div>

    </div> -->
    <div>
        <label for="stage" class="form-label" style="margin-left: 10px;"># of Stages:</label>
    </div>
    <div class="col-4 m-1">
       

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="+trainDetails.Stages == 1" >
            <option *ngFor="let stages of stageTotal" [value]="stages.Id"
                [selected]="stages.Id === trainDetails.Stages">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="+trainDetails.Stages == 2" >
            <option *ngFor="let stages of stage2" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>

        <select class="form-select border border-dark" [(ngModel)]="Stage1" name="Stage1" id="Stage1"
            *ngIf="+trainDetails.Stages == 3">
            <option *ngFor="let stages of stage3" [value]="stages.Id">
                {{ stages.Name }}
            </option>
        </select>
    </div>
    <div>
        <label for="date1" class="form-label" style="margin-left: 10px;">Date 1:</label>
    </div>
    <div class="col-4 m-1">
        <select class="form-select border border-dark" [(ngModel)]="date1" name="date1" id="date1">
            <option [selected]="true"  [value]="0">Select One</option>
            <option *ngFor="let date1 of distinctDates" [value]="date1.TableshortcodeDatetime">
                {{ date1.TableshortcodeDatetime | date:'yyyy-MM-dd H:mm:ss'}}
            </option>
        </select>
    </div>
    <div>
        <label for="date2" class="form-label" style="margin-left: 10px;">Date 2:</label>
    </div>
    <div class="col-4 m-1">
        
        <select class="form-select border border-dark" name="date2" [(ngModel)]="date2" id="date2">
            <option [selected]="true"  [value]="0">Select One</option>
            <option *ngFor="let date2 of distinctDates" [value]="date2.TableshortcodeDatetime">
                {{ date2.TableshortcodeDatetime | date:'yyyy-MM-dd H:mm:ss'}}
            </option>
        </select>
    </div>
    <div>
        <label for="date3" class="form-label" style="margin-left: 10px;">Date 3:</label>
    </div>
    <div class="col-4 m-1">
        <select class="form-select border border-dark" name="date3"  [(ngModel)]="date3" id="date3">
            <option [selected]="true"  [value]="0">Select One</option>
            <option *ngFor="let date3 of distinctDates" [value]="date3.TableshortcodeDatetime">
               
                {{ date3.TableshortcodeDatetime | date:'yyyy-MM-dd H:mm:ss'}}
            </option>
        </select>
    </div>
    <div class="row  mb-3 mt-2">
        <div class="col-5">
            <button type="button" class="btn" (click)="showGraph()">
                Generate Conductivity Profile Graph
            </button>
        </div>
    </div>
</div>
<div class="row" style="text-align: center;">

    <div id="plot" style="border:deepskyblue;" style="height: 700px;width:NewWidth">
    </div>
</div>